import { useCallback, useEffect, useRef, useState } from "react";
import { queryShowAllZonesButton } from "./show-all-zones-query";

export const useShowAllZones = () => {
	const [showingAllZones, setShowingAllZones] = useState(false);

	const flipShowingAllZones = useCallback(() => {
		setShowingAllZones((showingAllZones) => !showingAllZones);
	}, []);

	const handleShowAllZonesButtonClick = useCallback(() => {
		flipShowingAllZones();
	}, [flipShowingAllZones]);

	useEffect(() => {
		const buttonElement = queryShowAllZonesButton();

		if (!buttonElement) {
			return;
		}

		buttonElement.addEventListener("click", handleShowAllZonesButtonClick);

		return () => {
			buttonElement.removeEventListener("click", handleShowAllZonesButtonClick);
		};
	}, [handleShowAllZonesButtonClick]);

	return {
		showingAllZones,
	};
};
